module.exports = __webpack_public_path__ + "static/scale-model-of-washington-d.c.-c6b7d517663cbe67de6d585b17aea903.png";